<template>
  <div class="order-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'order_list'}" class="float-left mr-1 main-link">{{$t('order.orders')}}</router-link> / {{$t('order.order_detail')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="basic-info header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('menu.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row" v-if="item != null">
                <b-col cols="12">
                  <div class="form-group row" v-show="checkShowByConfig('order_number')">
                    <strong class="col-sm-3">{{$t('order.order_number')}}</strong>
                    <label class="col-sm-5">{{item.order_number}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('external_order_id')">
                    <strong class="col-sm-3">{{$t('order.external_order_id')}}</strong>
                    <label class="col-sm-5" v-show="item.system != 'UberEats'">{{item.external_order_id}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('order_status')">
                    <strong class="col-sm-3">{{$t('order.status')}}</strong>
                    <label class="col-sm-5" v-if="item.order_status">{{item.is_not_refund == 1 ? $t('order.order_status_24') : showStatusName(item) }}</label>
                  </div><hr>

                  <!-- <hr>
                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.credit_card_status')}}</strong>

                    <label class="col-sm-5">Authorizations Complete</label>
                  </div>

                  <hr>
                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.automatic_alert_phone_status')}}</strong>

                    <label class="col-sm-5">____</label>
                  </div> -->

                  <!-- <hr>
                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.remind_email_status')}}</strong>

                    <label class="col-sm-5">Not sent</label>
                  </div> -->

                  <div class="form-group row" v-show="checkShowByConfig('customer_name')">
                    <strong class="col-sm-3">{{$t('order.name')}}</strong>
                    <label class="col-sm-5">{{item.name}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('street_address')">
                    <strong class="col-sm-3">{{$t('order.street_address')}}</strong>
                    <label class="col-sm-5">{{item && item.order_type.toLowerCase() == 'd' ? ((item.address && item.address.length > 0) ? item.address : (item.address_name2 + ' ' + item.address_name3) ) : item.outlet_address}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('phone')">
                    <strong class="col-sm-3">{{$t('order.phone')}}</strong>
                    <label class="col-sm-5">{{item.phone}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('email')">
                    <strong class="col-sm-3">{{$t('order.email')}}</strong>
                    <label class="col-sm-5">{{item.email}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('outlet_name')">
                    <strong class="col-sm-3">{{$t('order.store_name')}}</strong>
                    <label class="col-sm-5">{{item.outlet_name}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('member_id')">
                    <strong class="col-sm-3">{{$t('order.member_id')}}</strong>
                    <label class="col-sm-5">{{item.user_id}}</label>
                  </div>

                  <div class="form-group row" v-show="checkShowByConfig('sales_channel')">
                    <strong class="col-sm-3">{{$t('order.sale_channel')}}</strong>
                    <label class="col-sm-5">{{item.deveice_type}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('order_type')">
                    <strong class="col-sm-3">{{$t('order.order_type')}}</strong>
                    <label class="col-sm-5">{{ (item.order_type.toLowerCase() == 'c' && item.referral_code === 'qr') ? $t('order.order_c_qr') : $t('order.order_' + item.order_type.toLowerCase())}}</label>
                  </div><hr>

                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order.created_at')}}</strong>
                    <label class="col-sm-5">{{convertUTCToTimeZone(item.created_at, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('waiting_time_reservation_date_time')">
                    <strong class="col-sm-3">{{$t('order.waiting_time_reservation_date_time')}}</strong>
                    <label class="col-sm-5">{{convertUTCToTimeZone(item.collection_time, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('payment_method')">
                    <strong class="col-sm-3">{{$t('order.payment_method')}}</strong>
                    <label class="col-sm-5">{{item.payment_method}}</label>
                  </div><hr>

                  <div class="form-group row" v-if="checkShowByConfig('gift')">
                    <strong class="col-sm-3">{{$t('order.gift')}}</strong>
                    <label class="col-sm-5">{{orderIsGift(item)}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('order_note')">
                    <strong class="col-sm-3">{{$t('order.order_note')}}</strong>
                    <label class="col-sm-5" v-html="item.note"></label>
                  </div><hr>

                  <!-- <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.issuing_receipt')}}</strong>

                    <label class="col-sm-5">{{item.note}}</label>
                  </div><hr> -->

                  <div class="form-group row" v-show="checkShowByConfig('total_order_amount')">
                    <strong class="col-sm-3">{{$t('order.total_order_amount')}}</strong>
                    <label class="col-sm-5">{{item.sub_total}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('discount_amount')">
                    <strong class="col-sm-3">{{$t('order.discount_amount')}}</strong>
                    <label class="col-sm-5">{{item.total_discount}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('payment_credit_cart')">
                    <strong class="col-sm-3">{{$t('order.payment')}}</strong>
<!--                    <label class="col-sm-5" v-if="item.payment_method=='credit_card'">{{item.order_payment.price}}</label>-->
                    <label v-if="showJPGiftCard" class="col-sm-5">{{item.total - (item.paid_by_giftcard_amount || 0)}}</label>
                    <label v-else class="col-sm-5">{{item.total}}</label>
                  </div><hr>

                  <div v-show="showJPGiftCard" class="form-group row">
                    <strong class="col-sm-3">{{ 'Giftcard used' }}</strong>
                    <label class="col-sm-5">{{item.paid_by_giftcard_amount && item.paid_by_giftcard_amount > 0 ? $t('common.yes') : $t('common.no')}}</label>
                  </div><hr v-show="showJPGiftCard">

                  <div v-show="showJPGiftCard" class="form-group row">
                    <strong class="col-sm-3">{{ 'Giftcard amount' }}</strong>
                    <label class="col-sm-5">{{item.paid_by_giftcard_amount || 0}}</label>
                  </div><hr v-show="showJPGiftCard">

                  <div class="form-group row" v-show="showLateDelivery && item.order_type == 'D'">
                    <strong class="col-sm-3">{{$t('order.late_delivery')}}</strong>
                    <label class="col-sm-5">{{(item.is_late_delivery || 0)  == 1 ? $t('common.yes') : $t('common.no')}}</label>
                  </div><hr v-show="showLateDelivery">

                  <!-- <hr>
                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.point_usage_amount')}}</strong>

                    <label class="col-sm-5">0</label>
                  </div> -->
                  <div v-show="item.point > 0">
                  <div class="form-group row" v-show="checkShowByConfig('payment_cash')">
                    <strong class="col-sm-3">{{$t('order.cash_payment_amount')}}</strong>
                    <label class="col-sm-5" v-if="item.payment_method=='cash'">{{item.order_payment.price}}</label>
                    <label class="col-sm-5" v-else>0</label>
                  </div><hr>
                  <!-- <hr>
                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.ponta_id')}}</strong>

                    <label class="col-sm-5">456486789515464</label>
                  </div> -->
                  <div class="form-group row" v-show="checkShowByConfig('usage_point')">
                    <strong class="col-sm-3">{{isJPMarket && !item.system ? $t('order.usage_slices') : $t('order.usage_point')}}</strong>
                    <label class="col-sm-5">{{item.point}}</label>
                  </div><hr>
                  </div>
                  <!-- <hr>
                  <div class="form-group row">
                    <strong class="col-sm-3">{{$t('order-phil.granted_point')}}</strong>

                    <label class="col-sm-5">22</label>
                  </div> -->

                  <div class="form-group row" v-show="checkShowByConfig('order_confirmation_email_sent_time')">
                    <strong class="col-sm-3">{{$t('order.order_confirmation_email_sent_time')}}</strong>
                    <label class="col-sm-5">{{item.email_confirmation_time ? convertUTCToTimeZone(item.email_confirmation_time, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss'): item.email_confirmation_time}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('order_completed_email_sent_time')">
                    <strong class="col-sm-3">{{$t('order.order_completed_email_sent_time')}}</strong>
                    <label class="col-sm-5">{{item.email_complete_time ? convertUTCToTimeZone(item.email_complete_time, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss') : item.email_complete_time}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('order_ip_address')">
                    <strong class="col-sm-3">{{$t('order.order_ip_address')}}</strong>
                    <label class="col-sm-5">{{item.user_ip}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('order_user_agent')">
                    <strong class="col-sm-3">{{$t('order.order_user_agent')}}</strong>
                    <label class="col-sm-5">{{item.user_agent}}</label>
                  </div><hr>

                  <div class="form-group row" v-show="checkShowByConfig('pos_response_status')">
                    <div class="col-sm-3">
                      <strong>{{$t('order.pos_response_status')}}</strong>
                    </div>
                    <div class="col-sm-9">
                        <table class="table table-hover" style="table-layout: fixed; overflow-wrap: break-word;">
                            <thead class="thead-light">
                                <tr>
                                  <th scope="col" width="20%">{{$t('common.date')}} {{$t('common.time')}}</th>
                                  <th scope="col" width="15%">{{$t('order.pos_response_code')}}</th>
                                  <th scope="col">{{$t('order.pos_response_message')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pos,index) in item.posResponse" :key="index+0">
                                    <td>{{convertUTCToTimeZone(pos.created_at.date, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</td>
                                    <td>{{ pos.code }}</td>
                                    <td v-if="country_code!= 'JP'">
                                      <pre v-if="isJsonString(pos.message)">{{ formatPosMessageToJson(pos.message) }}</pre>
                                      <samp v-else>{{ pos.message }}</samp>
                                    </td>
                                    <td v-else>{{ $t('pos_response.'+pos.code) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
                  <div v-if="showJPGiftCard" class="form-group row">
                    <div class="col-sm-3">
                      <strong>{{$t('giftcard.transaction_logs.title_payment_response_status')}}</strong>
                    </div>
                    <div class="col-sm-9" style="overflow-x: auto;">
                        <table class="table table-hover">
                            <thead class="thead-light">
                                <tr>
                                  <th scope="col" width="20%">{{$t('common.date')}} {{$t('common.time')}}</th>
                                  <th scope="col" width="15%">{{$t('giftcard.transaction_logs.payment_response_status')}}</th>
                                  <th scope="col" width="30%">{{$t('giftcard.transaction_logs.payment_card_number')}}</th>
                                  <th scope="col">{{$t('giftcard.transaction_logs.payment_response_details')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(log,index) in giftcard_payment_logs" :key="index+0">
                                <tr :key="index">
                                    <td>{{convertUTCToTimeZone(log.transaction_status_created_at, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</td>
                                    <td>{{ `${log.code}` || '?' }}</td>
                                    <td>
                                      <i class="fa fa-credit-card"></i>&nbsp;{{log.card_number ? log.card_number.slice(-4).padStart(log.card_number.length, '*') : '?'}}<br />
                                      <i class="fa fa-external-link"></i>&nbsp;{{log.transaction_id || '?'}}
                                    </td>
                                    <td>{{log.transaction_status || '?'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
                  <div class="form-group row" v-show="checkShowByConfig('credit_response_status')">
                    <div class="col-sm-3">
                      <strong>{{$t('order.credit_response_status')}}</strong>
                    </div>
                    <div class="col-sm-9" style="overflow-x: auto;">
                        <table class="table table-hover">
                            <thead class="thead-light">
                                <tr>
                                  <th scope="col">{{$t('common.date')}} {{$t('common.time')}}</th>
                                  <th scope="col">{{$t('order.payment_response_status')}}</th>
                                  <th scope="col">{{$t('order.payment_response_details')}}</th>
                                  <th scope="col">{{$t('order.payment_step')}}</th>
                                  <th scope="col">{{$t('order.payment_transaction_id')}}</th>
                                  <th scope="col" v-show="order.config.payment_log">{{$t('order.log')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(log,index) in payment_logs" :key="index+0">
                                    <td>{{convertUTCToTimeZone(log.created_at, item.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</td>
                                    <td>{{ log.detail && log.detail.res_result }}</td>
                                    <td>{{ log.step }}</td>
                                    <td><pre>{{ formatJsonString(log.detail) }}</pre></td>
                                    <td>{{ log.detail && log.detail.res_sps_transaction_id }}</td>
                                    <td v-show="order.config.payment_log">
                                      <span v-if="log.detail != null">
                                        <pre>{{log.detail}}</pre>
                                      </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>

                  <customize-field style="font-weight: bold;" label_cols="3" prefix="order" :item="item" type="order" position="before" element="name_seo"></customize-field>
                  <customize-field style="font-weight: bold;" label_cols="3" prefix="order" :item="item" type="order" position="after" element="name_seo"></customize-field>

                  <!-- <div class="form-group row">
                    <b-col cols="3">
                      <strong class="col-sm-3">{{$t('order-phil.ponta_response_status')}}</strong>
                    </b-col>
                    <b-col cols="9">
                        <b-row id="at_store">
                            <table class="table table-hover">
                                <thead class="thead-light">
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Time</th>
                                        <th scope="col">POS Response Code (POS Response Message) [POS Response Segment]</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2019/01/28</td>
                                        <td>16:58:37</td>
                                        <td>000 [Primary Response]</td>
                                    </tr>
                                   <tr>
                                        <td>2019/01/28</td>
                                        <td>16:58:37</td>
                                        <td>000 [Primary Response]</td>
                                    </tr>
                                </tbody>
                            </table>
                      </b-row>
                    </b-col>
                  </div> -->
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <!--<router-link :to="{ name: 'order_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>-->
              <button class="btn border-radius-4px bg-main float-left ml-4" v-on:click="goBack()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="btn-save">
                <button type="button" @click="resendMail(item.order_number)"  v-show="order.config.resend_mail" class="btn bg-main border-radius-4px pl-3 pr-3">{{$t('order.resend_mail')}}</button>
                <button type="button" @click="processOrder(uuid,2)" v-bind:class="{'btn-disable': (_.indexOf([1,4], item.status) < 0)}" v-show="order.config.resend && order.config.pending_order" :disabled="item.proceess || _.indexOf([1,4], item.status) < 0" data-order-status="1" class="btn bg-main border-radius-4px pl-3 pr-3">{{$t('order.resend')}}</button>
                <button type="button" @click="processOrder(uuid,2)" v-bind:class="{'btn-disable': (_.indexOf([4], item.status) < 0)}" v-show="order.config.resend && order.config.error_order && !order.config.pending_order" :disabled="item.proceess || _.indexOf([4], item.status) < 0" data-order-status="4" class="btn bg-main border-radius-4px pl-3 pr-3">{{$t('order.resend')}}</button>
                <button type="button" @click="processOrder(uuid,2)" v-bind:class="{'btn-disable': (_.indexOf([22], item.status) < 0)}" v-show="order.config.resend && !order.config.error_order && !order.config.pending_order" :disabled="item.proceess || _.indexOf([22], item.status) < 0" data-order-status="22" class="btn bg-main border-radius-4px pl-3 pr-3">{{$t('order.resend')}}</button>
                <button type="button" @click="processOrder(uuid,8)" v-bind:class="{'btn-disable': ((_.indexOf([7, 9], item.status) >= 0) || ((_.indexOf([8], item.status) >= 0) && item.is_not_refund == 0))}" v-show="order.config.cancel" :disabled="item.proceess || _.indexOf([7, 9], item.status) >= 0 || ((_.indexOf([8], item.status) >= 0) && item.is_not_refund == 0)" class="btn bg-main border-radius-4px pl-3 pr-3">{{$t('order-phil.cancel')}}</button>
                <button type="button" @click="processOrder(uuid,9)" v-bind:class="{'btn-disable': ((_.indexOf([7, 8, 9], item.status) >= 0) || ((_.indexOf([28], item.status) >= 0) && item.is_not_refund == 0))}" v-show="order.config.complete" :disabled="item.proceess || _.indexOf([7, 8, 9], item.status) >= 0 || ((_.indexOf([28], item.status) >= 0) && item.is_not_refund == 0)" class="btn bg-main border-radius-4px pl-3 pr-3"> {{$t('order-phil.complete')}}</button>
                <button type="button" @click="processOrder(uuid,10)" v-show="order.config.proceed" :disabled="item.proceess" class="btn bg-main border-radius-4px pl-3 pr-3"> {{$t('order-phil.proceed')}}</button>
              </div>
            </div>
          </b-card>
          <!-- ORDER DETAIL -->
          <b-card class="order-detail mb-0">
            <div slot="header">
              <strong class="text-uppercase">{{$t('order.order_detail')}}</strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateStoreSettingsStatus" v-b-toggle.order_detail_settings>
                <i class="fa fa-sort-down" v-if="storeSettings"></i>
                <i class="fa fa-sort-up" v-if="!storeSettings"></i>
              </label>
            </div>

            <b-collapse :visible.sync="storeSettings" id="order_detail_settings">
              <div class="wrap">
                <div id="storeGroupChoose1" class="blocks">
                    <table class="table table-hover table-bordered">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">{{$t('order.product')}}</th>
                                <th scope="col">{{$t('order.unit_price')}}</th>
                                <th scope="col">{{$t('order.quantity')}}</th>
                                <th scope="col">{{$t('order.total')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order,index) in item.order_items" :key="index+0">
                                <td>
                                  <div v-if="order.type == 0 || order.type == 2 || order.type == 3">
                                    <div class="item-name" v-if="order.type == 2">
                                      <strong>{{order.name}}</strong>
                                    </div>
                                    <div v-for="(sub_item, sub_index) in order.items" :key="sub_index+0">
                                      <div class="item-row">
                                        <div class="item-name">
                                          <strong>{{sub_item.name}}</strong>
                                        </div>
                                      </div>
                                      <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                                        <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                                      </div>
                                      <div class="item-row" v-for="(topping,index) in sub_item.topping.extra" :key="index+0">
                                        <div v-if="topping.quantity > 1" class="topping-name">{{$t('common.add')}} {{topping.quantity}} x {{topping.name}}</div>
                                        <div v-else class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                                      </div>
                                      <div class="item-row" v-for="(topping,index) in sub_item.topping.remove" :key="index+0">
                                        <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                                        <div class="item-price"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="order.type == 1">
                                    <div class="item-row">
                                      <div class="item-name">
                                        <strong>{{order.name}}</strong>
                                      </div>
                                    </div>
                                    <div v-for="(sub_item, sub_index) in order.items" :key="sub_index+0">
                                      <div class="item-row">
                                        <div class="item-name">
                                          {{sub_item.name}}
                                        </div>
                                      </div>
                                      <div v-if="sub_item.items!= null && sub_item.items.length">
                                        <div v-for="(sub_sub_item, sub_sub_index) in sub_item.items" :key="sub_sub_index+0">
                                          <div class="item-row">
                                            <div class="option-name">
                                              {{sub_sub_item.name}}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="item-row" v-if="sub_item.first && sub_item.first.second && sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                                        <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                                      </div>
                                      <div v-if="sub_item.topping">
                                        <div class="item-row" v-for="(topping,index) in sub_item.topping.extra" :key="index+0">
                                          <div class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                                        </div>
                                        <div class="item-row" v-for="(topping,index) in sub_item.topping.remove" :key="index+0">
                                          <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>{{order.type === 2 ? getPriceHH(order) : order.price}}</td>
                                <td>{{order.quantity}}</td>
                                <td>{{order.type === 2 ? getTotalHH(order) : order.total}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--EXTRA FEE-->
                <div class="blocks">
                  <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">{{$t('order.extra_fee')}}</th>
                        <th scope="col">{{$t('order.total')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{$t('store.delivery_fee')}}</td>
                        <td>{{item.delivery_fee || 0}}</td>
                      </tr>
                      <tr>
                        <td>{{$t('store.service_fee')}}</td>
                        <td>{{item.service_fee || 0}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--APPLIED COUPONS-->
                <div class="blocks">
                  <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">{{$t('store.coupon_code')}}</th>
                        <th scope="col">{{$t('store.coupon_name')}}</th>
                        <th scope="col">{{$t('order.quantity')}}</th>
                        <th scope="col">{{$t('order.total')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(coupon, index) in item.order_coupons" :key="index">
                        <td>{{coupon.coupon_code}}</td>
                        <td>{{coupon.coupon_name}}</td>
                        <td>{{coupon.discount_quantity}}</td>
                        <td>{{coupon.discount}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--./APPLIED COUPONS-->
                <!--APPLIED VOUCHER-->
                <div class="blocks" v-if="isMYMarket">
                  <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">{{$t('order.voucher_code')}}</th>
                        <th scope="col">{{$t('order.voucher_name')}}</th>
                        <th scope="col">{{$t('order.quantity')}}</th>
                        <th scope="col">{{$t('order.total')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(voucher, index) in getListVoucherApply()" :key="index">
                        <td>{{voucher.code}}</td>
                        <td>{{voucher.name}}</td>
                        <td>{{voucher.quantity}}</td>
                        <td>{{voucher.total}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--./APPLIED VOUCHER-->
                <div id="free-test" class="blocks">
                  <div class='wrap'>
                    <div class="blocks" style="padding-left:15px;">
                      <strong style="color:red;">{{$t('order.order_transmission_title')}}</strong> <br/>
                      <span v-html="$t('order.order_transmission_content')"></span>
                    </div>
                    <div class="blocks" style="padding-left:15px;padding-top:20px;">
                      <strong style="color:red;">{{$t('order.order_cancel_title')}}</strong> <br/>
                      <span v-html="$t('order.order_cancel_content')"></span>
                    </div>
                    <div class="blocks" style="padding-left:15px;padding-top:20px;">
                      <strong style="color:red;">{{$t('order.order_completion_title')}}</strong><br/>
                      <span v-html="$t('order.order_completion_content')"></span>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { sortBy } from 'lodash'
import CustomizeField from '../../../components/Partials/CustomizeField'
let app = null
const CANCELLED_STATUS = 8
export default {
  name: 'OrderDetail',
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  components: {
    CustomizeField
  },
  data: function () {
    return {
      order: this.$store.getters.config.gms.order,
      item: {
        proceess: false,
        address: "",
        address_code1: null,
        address_code2: null,
        address_name1: null,
        address_name2: null,
        advance_order: 0,
        client_id: 0,
        collection_time: "",
        created_at: "",
        currency: "",
        delivery_fee: null,
        device_type: null,
        email: "",
        id: 0,
        country_code: '',
        kata_name: null,
        name: "",
        note: null,
        order_coupon: [],
        order_items: [],
        order_number: "",
        order_payment: {},
        order_type: "",
        outlet_address: "",
        outlet_code: "",
        outlet_id: 0,
        outlet_name: "",
        payment_method: "",
        phone: "",
        status: 0,
        sub_total: 0,
        tax_percent: 0,
        tax_total: 0,
        total: 0,
        total_discount: 0,
        updated_at: "",
        user_agent: "",
        user_id: null,
        uuid: ""
      },
      payment_logs: [],
      giftcard_payment_logs: [],
      storeSettings: true,
      basicInformationStatus: true,
      isJPMarket: false,
      showLateDelivery: false,
      GIFTCARD_STATUS_CODES: {
        'giftcard.redemption_status.created': '201',
        'giftcard.redemption_status.success': '200',
        'giftcard.redemption_status.cancelled': '499',
        'giftcard.redemption_status.cancel_failed': '500',
        'giftcard.redemption_status.failed_bad_request': '400',
        'giftcard.redemption_status.failed_server': '500',
        'giftcard.redemption_status.failed_unknown': '520',
      },
      showJPGiftCard: false,
      isMYMarket: false,
    }
  },
  created :function() {
    const vm = this
    this.country_code = JSON.parse(localStorage.getItem('vue-session-key')).config.country_code
    this.isJPMarket = localStorage.getItem('clientID') === this.client_uuid.jp
    this.isMYMarket = localStorage.getItem('clientID') === this.client_uuid.my
    this.showLateDelivery = this.checkShowLateDelivery()
    this.showJPGiftCard = this.checkShowJPGiftCard()
  },
  methods: {
    getListVoucherApply() {
      if (!this.item || (!this.item.rm_voucher_code && !this.item.rm_voucher_name)) return [];
      const codes = (this.item.rm_voucher_code || '').split('|');
      const names = (this.item.rm_voucher_name || '').split('|');
      const totals = (this.item.rm_voucher_amount_for_each || '').split('|');
      const listVoucher = codes.map((code, idx) => ({
        code: code,
        name: names[idx] || '',
        quantity: 1,
        total: totals[idx] || '',
      }));
      return listVoucher;
    },
    orderIsGift (item) {
       return item.special_types && (item.special_types['gift'] === 1 || item.special_types['gift'] === "1") ? this.$t('common.yes') : this.$t('common.no')
    },
    goBack () {
      this.$router.go(-1)
    },
    checkShowByConfig (key) {
      if (this.order == null) {
        return true
      }
      let config = this._.find(this.order.basic_info, function (o) {
        return o.type === key
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    checkDisableByConfig (key) {
      if (this.order == null) {
        return false
      }
      let config = this._.find(this.order.basic_info, {type: key})
      if (config == null) {
        return false
      }
      return config.disable
    },
    processOrder (uuid, status) {
      var vm = this
      var uuidKey = uuid
      var statusKey = status
      let options = {
        html: true,
        okText: this.$t('common.ok'),
        cancelText: this.$t('common.cancel')
      }
      let title = this.$t('order.confirm_title_change_status')
      if (status == 2) {
        title = this.$t('order.confirm_title_resend_status')
      }

      let payload = { status: statusKey }
      if (this.isJPMarket && statusKey === CANCELLED_STATUS) {
        payload = { ...payload, is_manually_cancelled: 1 }
      }
      this.$dialog.confirm(title, options)
        .then(function (dialog) {
          vm.item.proceess = true
          app = vm
          app.axios.order.getOrderDetailForProcessAction(uuidKey, payload,
            function (response) {
              const status = response.data.data.item.order_status
              app.item.proceess = false
              app.item.status = statusKey
              app.$toastr.success(app.$t('message.update_successful'), app.$t('message.success'), {})
              app.$set(app.item, 'order_status', (app.isJPMarket && status.id === CANCELLED_STATUS) ? { ...status, name: app.$t('order.order_status_88', app.$session.get('lang') || 'en') }  : status)
            })
        })
        .catch(function () {
        })
    },
    mapGiftcardStatusCode(code) {
      return this.GIFTCARD_STATUS_CODES[code]
    },
    orderDetail(){
        app = this
        app.axios.order.getOrderDetail(app.uuid,
        function (response) {
            let item = response.data.data.item
            if(item){
              item.note = item.note ? item.note.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''

              app.item = item
              app.item = app.mapOrderDetail(item);
              if (item.payment_method != 'cash' && item.payment_method != '現金払い') {
                app.getPaymentLogs(item.order_number)
              }

              switch (item.client_id) {
                case 1: { // Japan market
                  // If order_cart_uuid is not available, make giftcard logs empty
                  if (!item.order_cart_uuid) {
                    app.giftcard_payment_logs = []
                    break;
                  }

                  // Otherwise, get giftcard logs
                  app.axios.giftcard.getGiftCardTransactionStatusesLogs({
                    cartUuid: item.order_cart_uuid,
                  }, (transactionResponse) => {
                    if (transactionResponse.data.status) {
                      const { data } = transactionResponse.data
                      app.giftcard_payment_logs = data ? sortBy(data, ['timestamp'], ['asc']).map((item) => {
                        return {
                          transaction_status_created_at: moment.unix(Number(item.timestamp / 1000)).format('YYYY-MM-DDTHH:mm:ssZ'),
                          card_number: item.card_number || '?',
                          transaction_id: item.transaction_source || '?',
                          code: app.mapGiftcardStatusCode(item.transaction_status) || '000',
                          transaction_status: app.$t(item.transaction_status),
                        }
                      }) : []
                    } else {
                      app.giftcard_payment_logs = []
                    }
                  }, (error) => {
                    console.error(error, 'ERROR_OCCURRED_GETTING_GIFTCARD_TRANSACTION_STATUS_LOGS');
                    app.giftcard_payment_logs = []
                  })
                  break;
                }
                default: { // Other markets, hide giftcard logs without getting data
                  app.giftcard_payment_logs = []
                  break;
                }
              }
            }
        })
    },
    getPriceHH (order) {
      let result = 0;
      if (order && order.items && order.items.length > 0) {
        order.items.forEach(element => {
          result += element.total || 0
        });
      }
      if (result > order.total && order.total > 0) {
        return order.total / order.quantity
      }
      return result;
    },
    getTotalHH (order) {
      let price = this.getPriceHH(order)
      return price * (order.quantity || 0);
    },
    updateStoreSettingsStatus () {
      this.storeSettings = this.storeSettings?false:true
    },
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    getPaymentLogs (orderNumber) {
      app=this
      app.axios.payment.getPaymentLogs(orderNumber,
      function (response) {
          let item = response.data.data.item
          if(item){
              app.payment_logs=item
          }
      })
    },
    formatJsonString (json) {
      try {
        return JSON.stringify(JSON.parse(json), null, 2)
      } catch (e) {
        return json
      }
    },
    formatPosMessageToJson(posMessage) {
      try {
        const index = posMessage.indexOf(': ')
        if (index === -1) {
          return posMessage
        }
        const description = posMessage.slice(0, index + 1)
        const json = posMessage.slice(index + 1)
        return description + '\n' + JSON.stringify(JSON.parse(json), null, 2)
      } catch (e) {
        return posMessage
      }
    },
    isJsonString(str) {
      const index = str.indexOf(': ')
      if (index === -1) {
        return false
      }
      try {
          const json = str.slice(index + 1)
          JSON.parse(json);
      } catch (e) {
          return false;
      }
      return true;
    },
    resendMail (orderNumber) {
      var vm = this
      let options = {
        html: true,
        okText: this.$t('common.ok'),
        cancelText: this.$t('common.cancel')
      }
      let title = this.$t('order.confirm_title_resend_mail')
      this.$dialog.confirm(title, options)
        .then(function (dialog) {
          vm.item.proceess = true
          app = vm
          app.axios.order.resendMailOrder({keyword: orderNumber},
            function (response) {
              app.item.proceess = false
              app.$toastr.success(app.$t('message.update_successful'), app.$t('message.success'), {})
            })
        })
        .catch(function () {
        })
    },
    mapOrderDetail(order) {
      if (order.client_id === this.$const.CLIENT_ABBREVIATION_ENUM.MY) {
        return {
          ...order,
          user_agent: order.channel === 'SSD' ? order.channel : order.user_agent,
        }
      }

      return order;
    },
  },
  mounted: function () {
    this.orderDetail()
  },
  computed: {
    showStatusName: () => {
      return function(order) {
        const orderStatus = order.order_status;
        if (!this.isJPMarket) return orderStatus.name
        if (orderStatus.id !== CANCELLED_STATUS) return orderStatus.name
        return this._.get(order, 'is_manually_cancelled', false) ? this.$t('order.order_status_88', this.$session.get('lang') || 'en')
        : this.$t('order.order_status_8', this.$session.get('lang') || 'en')
      }
    }
  }
}
</script>
<style>
  .order-form .btn-disable , .order-form .btn-disable:hover {
    background-color: #d1d4d7 !important;
    background: #d1d4d7 !important;
    opacity: 1;
  }
</style>
<style scoped>
    .order-form hr {
        display: block;
        margin-top: 0.5em;
        margin-left: auto;
        margin-right: auto;
        border-style: inset;
        border-width: 1px;
    }

    .order-form .table{
        border: 1px solid #d1d4d7;
    }
    .order-form .switch.switch-icon{
        margin-top: 5px;
    }

    .order-form .header-custom-switch{
        margin-top: 5px;
        margin-bottom: 0;
    }

    .order-form .header-custom-switch .col-form-label{
        text-align: right;
    }

    .order-form .header-custom-switch .uppercase{
        display: inline-flex;
    }

    .order-form .btn-save{
        float: right;
        margin-right: 22px;
    }
    .order-form .card-footer{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 7.75px;
        border-top: none;
        margin-top: 1.5rem;
        z-index: 999;
    }
    .order-form div.header,
    .order-form .header .card-header{
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    }

    .basic-info div.card-body{
      padding-bottom:0rem !important;
    }

  .form-group {
      margin-bottom: 0rem;
      margin-top: -5px;
  }
  pre {
    font-size: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/order/BaseForm.vue